export default __webpack_public_path__ + "static/33-15986a8dd1f3ef1ab350ee80755c97e2.jpg";